import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getLocationData = (params, options) =>
  request.get(
    '/api/v4ward/nursing/location/manage/getLocationData',
    Object.assign({}, options, {
      params
    })
  );
  export const emergencycallpage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/emergency/call/page',
    Object.assign({}, options, {
      params
    })
  );

  export const healthmonitoringpage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/health/monitoring/page',
    Object.assign({}, options, {
      params
    })
  );

  export const homesafetypage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/home/safety/page',
    Object.assign({}, options, {
      params
    })
  );
  export const bedalarmpage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/bed/alarm/page',
    Object.assign({}, options, {
      params
    })
  );

  export const getCameraList = (params, options) =>
  request.get(
    '/api/v4ward/nursing/video/monitoring/getCameraList',
    Object.assign({}, options, {
      params
    })
  );
//   export const homesafetypage = (params, options) =>
//   request.get(
//     '/api/v4ward/nursing/home/safety/page',
//     Object.assign({}, options, {
//       params
//     })
//   );
